import { render } from "./FacultyCourseOutcomeScores.vue?vue&type=template&id=6902a0ea"
import script from "./FacultyCourseOutcomeScores.vue?vue&type=script&lang=js"
export * from "./FacultyCourseOutcomeScores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__